import { lazy } from 'react';

const StockIn = lazy(() => import('../../views/StockIn/index'));
const AddStockIn = lazy(() => import('../../views/StockIn/Tab/Pending/Form'));

const StockInRoutes = [
    {
        path: '/stock/stock-in',
        element: <StockIn />
    },
    {
        path: '/stock/stock-in/add',
        element: <AddStockIn />
    },
    {
        path: '/stock/stock-in/edit/:id',
        element: <AddStockIn />
    },
    {
        path: '/stock/stock-in/view/:id',
        element: <AddStockIn />
    }
];

export default StockInRoutes;
